import { render, staticRenderFns } from "./productDetailsBatch.vue?vue&type=template&id=430f7d1c&"
import script from "./productDetailsBatch.vue?vue&type=script&lang=js&"
export * from "./productDetailsBatch.vue?vue&type=script&lang=js&"
import style0 from "./productDetailsBatch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports